import { Link } from 'react-router-dom'

import styled from 'styled-components'

const RouterLink = styled(Link)`
  text-decoration: none;
  color: ${props => props.theme.colors.primary.tone700};
`

export default RouterLink
